import { useEffect } from "react";

export const useRenderSlot = (slot: googletag.Slot | null, refreshCount?: number) => {
  useEffect(() => {
    if (!slot) return;
    const isValidApsAdSlot = (slot: googletag.Slot) => slot.getSizes().some(s => s !== "fluid");

    if (isValidApsAdSlot(slot)) {
      apstag.fetchBids(
        {
          slots: [slot],
        },
        () => {
          googletag.cmd.push(() => {
            apstag.setDisplayBids();
            googletag.pubads().refresh([slot]);
          });
        },
      );
    } else {
      googletag.cmd.push(() => {
        googletag.pubads().refresh([slot]);
      });
    }
  }, [slot, refreshCount]);
};
